import { Box } from "@mui/material";

import LogoSvg from "../../atoms/LogoSvg/LogoSvg";
import VisaLogo from "../../../assets/images/MEAN_VISA.svg";
import PayPalLogo from "../../../assets/images/MEAN_PAYPAL.svg";
import MasterCardLogo from "../../../assets/images/MEAN_MASTERCARD.svg";
import MaestroLogo from "../../../assets/images/MEAN_MAESTRO.svg"
import IdealLogo from "../../../assets/images/MEAN_IDEAL.svg";
import AmericanExpressLogo from "../../../assets/images/MEAN_AMEX.svg";
import DefaultPaymentMeanLogo from "../../../assets/images/MEAN_DEFAULT.svg";
import SepaLogo from "../../../assets/images/MEAN_SEPA.svg";
import BancontactLogo from "../../../assets/images/MEAN_BANCONTACT.svg";
import CBLogo from "../../../assets/images/MEAN_CB.svg";
import { useTranslation } from "react-i18next";


import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import Text from "../../atoms/Text/Text";
import { MeanObject } from "../../../types/rtk/mean/mean";

interface Props extends MeanObject {
  onClick?: () => void;
}

const formatExpiry = (raw?: string) => {
  if (!raw) return "";
  const isoMatch = raw.trim().match(/^(\d{4})-(\d{2})-\d{2}T/);
  if (isoMatch) {
    const year = isoMatch[1];
    const month = isoMatch[2];
    return `${month}-${year}`;
  }
  return "";
};

const PaymentMeanCard = ({ provider_name, payment_product, mean_reference, card_expiry, expired, valid, onClick }: Props) => {

  // Replace x by • if it looks like a card number (contains only digits and 'x' or 'X')
  const formattedReference = mean_reference && /^[0-9xX]+$/.test(mean_reference)
    ? mean_reference.replace(/x/g, "•").replace(/X/g, "•")
    : mean_reference || "";

  const formattedExpiry = formatExpiry(card_expiry);
  const { t } = useTranslation();

  return (
    <>
      <Box className="PaymentMeanCard" onClick={onClick}>
        <Box className={`paymentMeanLogo`}>
          <LogoSvg src={
            payment_product === "paypal" ? PayPalLogo :
              payment_product === "visa" ? VisaLogo :
                payment_product === "mastercard" ? MasterCardLogo :
                  payment_product === "maestro" ? MaestroLogo :
                    payment_product === "american_express" ? AmericanExpressLogo :
                      payment_product === "sepa_debit" ? SepaLogo :
                        payment_product === "bancontact" ? BancontactLogo :
                          payment_product === "cartes_bancaires" ? CBLogo :
                            payment_product === "ideal" ? IdealLogo :
                              DefaultPaymentMeanLogo
          }
          />
        </Box>
        <Box className={`paymentMeanDetails ${expired || !valid ? 'invalid' : ''}`}>
          <Text children={(provider_name === "gocardless" || payment_product === "sepa_debit") ? t("subscription:MANAGE_MEAN.MEAN.DIRECT_DEBIT")
            : (payment_product === "paypal" && mean_reference) ? formattedReference
              : formattedReference
          } />
          <Text children={formattedExpiry ? `${t("subscription:MANAGE_MEAN.MEAN.EXPIRY_DATE")}: ${formattedExpiry}` : ""} />
        </Box>
        <Box className="paymentMeanAction">
          <Text children={t("subscription:MANAGE_MEAN.MEAN.EDIT")} />
        </Box>
        <Box className="paymentMeanArrow">
          <ArrowForwardIosIcon className="Logos" />
        </Box>
      </Box>
      <Box className="paymentMeanStatusText">
        {expired ? <Text className="paymentMeanDetailsExpiryText" children={t("subscription:MANAGE_MEAN.MEAN.EXPIRED")} />
          : !valid ? <Text className="paymentMeanDetailsExpiryText" children={t("subscription:MANAGE_MEAN.MEAN.INVALID")} />
            : null}
      </Box>
    </>
  );
};

export default PaymentMeanCard;